import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveDocumentTemplatesFolderRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveDocumentTemplatesFolderRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveDocumentTemplatesFolderRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getDocumentTemplatesFolder() {
      return getState().folder;
    },
  };
}

export { createSelector };
